import { useSportContext } from '@sorare/core/src/contexts/sport';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

export const useLastVisitedPlayTab = ({
  tab,
}: {
  tab: 'quickPlay' | 'play';
}) => {
  const { lifecycle, update, loading } = useLifecycle();
  const { sport } = useSportContext();

  if (lifecycle?.lastVisitedPlayTab?.[sport] !== tab && !loading) {
    update(LIFECYCLE.lastVisitedPlayTab, {
      ...lifecycle?.[LIFECYCLE.lastVisitedPlayTab],
      [sport]: tab,
    });
  }
};
